import { Box, Button } from '@mui/material'
import * as React from 'react'
import { useState } from 'react'
import { AddCircle } from '@mui/icons-material'
import PhaseAccordion from './PhaseAccordion'
import { useStudyContext } from '../../../Contexts/Modules/StudyModule/SelectedStudyModule'
import { useUserContext } from '../../../Contexts/UserConfig'
import NewPhaseModal from './NewPhaseModal'
import PageSection from '../../../Constants&Theme/PageSection'
import { useParams } from 'react-router-dom'

function PhaseList() {
  const { loginConfig } = useUserContext()
  const { studyQuery } = useStudyContext()
  const { study_id } = useParams()
  const [newPhase, setNewPhase] = useState(false)

  return (
    <PageSection
      title={'Phases'}
      rightDecorator={
        <Box>
          <Button
            endIcon={<AddCircle />}
            variant={'outlined'}
            onClick={() => setNewPhase(true)}
            disabled={!loginConfig?.Modules?.EditStudy || study_id === '1'}
          >
            New Phase
          </Button>
        </Box>
      }
    >
      {studyQuery.data && (
        <Box
          sx={{ flex: 2, display: 'flex', flexDirection: 'column', width: 1 }}
        >
          {studyQuery.data?.phases.map((phase, index) => (
            <PhaseAccordion
              phase={phase}
              index={index}
              key={phase.PhaseID}
            />
          ))}
        </Box>
      )}
      <NewPhaseModal
        open={newPhase}
        setOpen={setNewPhase}
      />
    </PageSection>
  )
}

export default PhaseList
